import { Observable } from "rxjs";
import { BaseResponse } from "../../models";
import { FaqsRequestDTO, HelpAndSupportRequestDTO } from "../../models/admin/help-and-support";

export abstract class HelpAndSupport {
    abstract getHelpAndSupportInfo(id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>>;
    abstract saveHelpAndSupport(data?: HelpAndSupportRequestDTO, id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>>;
    abstract deleteHelpAndSupport(id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>>;

    abstract getFaqs(data?: FaqsRequestDTO, id?: any, categoryName?: string): Observable<BaseResponse<FaqsRequestDTO[]>>;
    //abstract getCategory(id?: any, categoryName?: string): Observable<BaseResponse<any[]>>;
    abstract editCategory(data?: any): Observable<BaseResponse<any>>;

    abstract saveFaqs(data?: FaqsRequestDTO | FaqsRequestDTO[]): Observable<BaseResponse<any>>;
    abstract getCategory(): Observable<BaseResponse<any[]>>;
    abstract deleteFaqs(id: any): Observable<BaseResponse<any>>;
    abstract deletefaqscategory(category: any): Observable<BaseResponse<any>>;c

      abstract getContactUs(id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>>;
    abstract updateContactUs(data?: any, id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>>;

      abstract getCallMeBack(id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>>;
    abstract updateCallMeBack(data?: any, id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>>;
}
